import React, { useEffect, useRef, useState } from 'react';
import './Solution.css';

const Solution = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1, rootMargin: isMobile ? '0px' : '-150px' }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const solutions = [
    {
      title: 'Automatiser vos workflows',
      description: 'Extraction de données et mise à jour automatique de vos outils internes, orchestration multi-outils (CRM, ERP, Drive, API) via agents IA.',
      icon: '/photo/solution/workflow_logo.png',
      logoClass: 'workflow-logo'
    },
    {
      title: "Intégrer l'IA à vos systèmes",
      description: "Navigation par prompt, développement d'un assistant interne, analyse automatique des retours utilisateurs.",
      icon: '/photo/solution/Integration_IA_logo.png',
      logoClass: ''
    },
    {
      title: 'Créer un logiciel IA personnalisé',
      description: "Estimateur du coût de travaux à partir de photos, prédicteur de pannes sur machines, vérification des normes de sécurité sur chantier via analyse vidéo.",
      icon: '/photo/solution/creation_logiciel_logo.png',
      logoClass: 'logiciel-logo'
    },
    {
      title: "Créer des agents IA",
      description: "Développement d'agents intelligents capables d'effectuer des tâches complexes de manière autonome, de prendre des décisions et d'interagir avec vos systèmes.",
      icon: '/photo/solution/agent_logo_site.png',
      logoClass: 'agent-logo'
    },
    {
      title: 'Créer des chatbots AI',
      description: "Conception de chatbots conversationnels personnalisés pour votre site web, applications ou réseaux sociaux, disponibles 24/7 pour vos clients.",
      icon: '/photo/solution/chatbot_site_img.png',
      logoClass: 'chatbot-logo'
    }
  ];

  return (
    <section id="solution" className={`solution ${isVisible ? 'visible' : ''}`} ref={sectionRef}>
      <div className="solution-container">
        <div className="solution-split-layout">
          {/* Titre fixe à gauche */}
          <div className="solution-left-sticky">
            <h2 className={`section-title fade-in-up ${isVisible ? 'visible' : ''}`}>Je vous aide a :</h2>
          </div>

          {/* Solutions à droite qui défilent */}
          <div className="solution-right-scroll">
            {solutions.map((solution, index) => (
              <div 
                key={index} 
                className={`solution-card fade-in-up delay-${(index % 3 + 1) * 100} ${isVisible ? 'visible' : ''}`}
              >
                <div className="solution-card-text">
                  <h3 className="solution-title">{solution.title}</h3>
                  <p className="solution-description">{solution.description}</p>
                </div>
                <div className="solution-card-logo">
                  <img 
                    src={solution.icon} 
                    alt="" 
                    className={`solution-icon ${solution.logoClass || ''}`} 
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solution;
